import axiosBase from "@/api/axiosBase";

const state = {
  model_decouple: "",
  fileData: "",
  modelFileData: "",
  modelComparee: "",



}

const mutations = {

  setModelDecouple(state, data) {
    state.model_decouple = data
  },

  setFileData(state, data) {
    state.fileData = data
  },

  // 保存解耦母模型的数据
  setModelFileData(state, newMessage) {
    state.modelFileData = newMessage;
  },

  setModelComparee(state, newMessage) {
    state.modelComparee = newMessage;
  }
}

const actions = {

  // 空间解耦
  modelDecouple({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/spatial/decouple',
        data: {
          "child_model_group_id": data.child_model_group_id,
          "child_model_name": data.child_model_name,
          "parent_model_id": data.parent_model_id,
          "parent_model_subids": data.parent_model_subids
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setModelDecouple', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取文件信息
  getFile({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/basedata/filebase/qb/' + data
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setFileData', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 保存解耦母模型的数据
  saveModelFileData({ commit }, newMessage) {
    commit('setModelFileData', newMessage);
  },

  // 模型比较
  modelCompare({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'POST',
        url: '/model/compare/default',
        data: {
          "model_id1": data.model_id1,
          "model_id2": data.model_id2,
        }
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setModelComparee', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

}

const getters = {

  // 保存解耦母模型的数据
  getModelFileData(state) {
    return state.modelFileData;
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}